// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SwQa","questions":"styles_questions__11nSZ","footer":"styles_footer__1x_5e"};